import React, { useMemo, useState } from 'react';
import { Link } from 'react-navi';
import { EntryCard, NavBar } from '@contest-web/components/src/components';
import { Helmet } from 'react-navi-helmet-async';

function Presenter() {
  return (
    <div>
      <Helmet>
        <meta
          content={`スペシャルプレゼンターとして昨年度グランプリ「永松野々花」さんの出演が決定致しました。 | ${
            process.env.REACT_APP_WEBSITE_NAME
          }`}
          property="og:title"
        />
        <meta content={`${process.env.REACT_APP_URL}/news/2019-11-11`} property="og:url" />
      </Helmet>
      <div className="hero">
        <div className="hero-head">
          <NavBar logoImageSrc="/images/logo_black.svg" />
        </div>
      </div>
      <section className="section is-padding-bottom-0">
        <div className="container">
          <nav className="breadcrumb is-right is-small-mobile" aria-label="breadcrumbs">
            <ul className="is-align-center">
              <li>
                <Link className="has-text-primary" href="/top">
                  TOP
                </Link>
              </li>
              <li className="is-active">
                <Link href={`/news/2019-11-11`} aria-current="page">
                  スペシャルプレゼンター決定!
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </section>
      <section className="section">
        <div className="container is-small">
          <div className="content">
            <h3>スペシャルプレゼンターとして昨年度グランプリ「永松野々花」さんの出演が決定致しました。</h3>
            <p>
              <a className="has-text-underline  has-text-primary" href="/news/2019-10-04">2019年11月17日(日)コンテスト表彰式</a>
              にて、昨年度グランプリに輝いた「永松野々花」さんがスペシャルプレゼンターとしてご登壇致します。
            </p>
            <figure>
              <img src="/images/presenter.jpg" width={320} />
              <figcaption className="is-margin-top-1">
                フレッシュキャンパスコンテスト2018グランプリ
                <br />
                永松野々花
              </figcaption>
            </figure>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Presenter;
